import { stageSchema } from '../stage-schema';
import { TStage } from '../types';

export const useGetStage = (stage: number): TStage | undefined => {
    if (!Object.keys(stageSchema).includes(String(stage))) {
        return;
    }
    return stageSchema[stage];
};
